import { graphql } from 'react-apollo'
import mutation from './mutation.graphql'

const mapMutateToProps = ({ mutate }) => ({
  updateBrowseStoresView: isListView => {
    mutate({
      variables: {
        settings: {
          browseStoresView: isListView ? 'list' : 'grid',
        },
      },
    })
  },
})

const withUpdateUserSettings = graphql(mutation, {
  props: mapMutateToProps,
})

export default withUpdateUserSettings
